import { AuthenticationService } from '@app/core/services/backend/authentication.service';
import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { AppLog } from '@services';
import { LogPriority } from '@services/log/log-priority.enum';
import { AuthStore } from '@app/store/auth.store';

export const AuthGuard: CanActivateChildFn | CanActivateFn = async (
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
    authStore = inject(AuthStore),
    logger: AppLog = inject(AppLog),
    authService: AuthenticationService = inject(AuthenticationService),
): Promise<boolean> => {
    if (!authStore.identity()) {
        const hasToken = !!sessionStorage.getItem(AuthenticationService.authTokenStoreKey);
        if (hasToken) {
            await authStore.identityReady();
        }
    }

    if (!authStore.identity()) {
        logger.info('AuthGuard: User identity not loaded. Redirecting to logout.', {
            logPriority: LogPriority.MEDIUM,
        });
        authStore.logout();
        return false;
    }
    const access = !authService.isExpired();
    if (!access) {
        logger.info('AuthGuard: User is not authenticated. Redirecting to logout.', {
            logPriority: LogPriority.MEDIUM,
        });
        authStore.logout();
    }
    return access;
};
